import store from "../../store";

const DocumentaleBrowser = () => import("./DocumentaleBrowser");

const ifAuthenticated = (to, from, next) => {
    // Se no te si dentro, te toca tornar al login.
    if (store.getters.isLoggedIn) {
        if (store.state.user.userdata?.groups?.includes("Fornitore")) {
            next({ name: "fornitore-magazzino" });
            return;
        }
        next();
        return;
    }
    next("/login");
};

export default [
    {
        path: "/documentale/",
        name: "documentale-browser",
        meta: { menu: "documentale", title: "Gestione Documentale" },
        component: DocumentaleBrowser,
        beforeEnter: ifAuthenticated,
    },
];
